import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/bureau`);

export default class BureauService {
  axios: typeof axiosInstance;

  constructor() {
    this.axios = axiosInstance;
  }

  solicitaBigData(cpf: string, idProposta: string, idusuario: string, tipoConsulta: string): void {
    this.axios.post(`/solicitar/${tipoConsulta}`, {
      cpf,
      idProposta,
      idusuario
    }).catch((error: any) => {
      console.error('Erro ao solicitar BigData:', error);
    });
  }

  async consultaSincrona(cpf: string, idProposta: string | null, idusuario: string, tipoConsulta: string, nome?: string | null): Promise<any> {
    try {
      const payload: any = { cpf, idusuario };
      if (idProposta) {
        payload.idProposta = idProposta;
      }
      if (nome) {
        payload.nome = nome;
      }
      const response = await this.axios.post(`/consultaSincrona/${tipoConsulta}`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro na consulta síncrona:', error);
      throw error;
    }
  }

  async consultaSincronaPorNumeroProposta(cpf: string, numeroProposta: string | null, idusuario: string, tipoConsulta: string, nome?: string | null): Promise<any> {
    try {
      const payload: any = { cpf, idusuario };
      if (numeroProposta) {
        payload.numeroProposta = numeroProposta;
      }
      if (nome) {
        payload.nome = nome;
      }
      const response = await this.axios.post(`/consultaSincrona/${tipoConsulta}`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro na consulta síncrona:', error);
      throw error;
    }
  }

    async geraRelatorioPdf(idProposta: string, tipoPdf: number, idBureau: number): Promise<Blob> {
    try {
        const response = await this.axios.post(
        '/gerarPdf', 
        { idProposta, tipoPdf, idBureau },
        {
            responseType: 'blob', // Isso é crucial para receber PDF/binários
        }
        );
        return new Blob([response.data], { type: 'application/pdf' });
    } catch (error) {
        console.error('Erro ao gerar PDF:', error);
        throw error;
    }
    }

  async consultarDossie(idProposta: string): Promise<any> {
    return await this.axios.get(`/consultar/${idProposta}`);
  }

  async consultarPassivelDeAnalise(idProposta: number): Promise<boolean> {
    try {
        const response = await this.axios.get('/consultarPassivelDeAnalise', {
        params: { idProposta },
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao consultar passivel de analise:', error);
        throw error;
    }
  }

}
